
import { ChangePasswordForm } from "./ChangePasswordForm";
import { KTCard } from "../../../_metronic/helpers";
import './styles.scss';

const ChangePasswordWrapper = () => {
  return (
    <>
      <KTCard>
        <ChangePasswordForm />
      </KTCard>
    </>
  );
};

export { ChangePasswordWrapper };
